export default "__VITE_PUBLIC_ASSET__1bf96899__"